import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { handleApiExceptions, alertify } from '../../app_methods';
import { EaseTable } from '../../libs/EaseTable';
import { getDisbursementsTableColumns, disbursementFilterNodes } from './constants';
import { isMobile } from 'react-device-detect';
import { SmartCollectDisbursements } from '../../models';
import DisbursementDetailsDrawer from './disbursement_details_drawer';
import { PermissionHoc } from '../HOC';
import FileSaver from 'file-saver';
import { PaginationKaBaap, BulkUploadModal } from '../Common';
import { toggleBulkRefundModalAction } from "../../redux/actions";

const Disbursements = (props) => {
    const [isTableLoading, setIsTableLoading] = React.useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = React.useState({});
    const [disbursements, setDisbursements] = React.useState([]);
    const [activeDisbursement, setActiveDisactiveDisbursement] = React.useState({});
    const [showDetailsDrawer, setShowDetailsDrawer] = React.useState(false);
    const [isDownloading, setIsDownloading] = React.useState(false);
    const [isSettlementDownloading, setIsSettlementDownloading] = React.useState(false);
    const [isSettlementMappingDownloading, setIsSettlementMappingDownloading] = useState(false);


    const toggleDisbursementDetailsDrawer = (data = {}) => {
        setActiveDisactiveDisbursement(data);
        setShowDetailsDrawer(!showDetailsDrawer);
    }

    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const fetchDisbursements = async (_pagination, _filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await SmartCollectDisbursements.list_v2({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        // setDisbursements(response.data.results);
        let disbursements = response.data.results
        disbursements = disbursements.map((account) => { return { ...account, is_submerchant:!!_filters.submerchant_id }})
        setDisbursements(disbursements);
        setPagination({ ..._pagination, ...response.data.pagination });
        setIsTableLoading(false);
    };

    const downloadReport = async () => {
        setIsDownloading(true);
        const response = await SmartCollectDisbursements.download_report({ ...prepFilters(filters) });
        if (response.status != 200) {
            setIsDownloading(false);
            handleApiExceptions("Something went wrong !");
            return;
        }
        FileSaver.saveAs(response.data, `InstaCollect Settlements & Refunds.csv`);
        setIsDownloading(false);
    };

    const downloadSettlementMappingReport = async () => {
        setIsSettlementMappingDownloading(true);

        try {
            const response = await SmartCollectDisbursements.download_settlement_mapping_report({
                ...prepFilters(filters)
            });

            if (!response.success) {
                const errorMessage =
                    response?.message ||
                    response?.data?.message ||
                    "Something went wrong!";

                handleApiExceptions(errorMessage);
                return;
            }

            const successMessage =
                response?.message ||
                response?.data?.message ||
                "Report generated successfully";

            alertify("Success", successMessage, "success");

        } catch (err) {
            handleApiExceptions("Unexpected error occurred");
        } finally {
            setIsSettlementMappingDownloading(false);
        }
    };

    const downloadSettlementReport = async (record) => {
        setIsSettlementDownloading(true);
        const response = await SmartCollectDisbursements.download_setlement_report(record.id);
        if (!response.success) {
            setIsSettlementDownloading(false);
            handleApiExceptions("Something went wrong!");
            return;
        }
        response?.data?.signed_url?window.open(response?.data?.signed_url, '_blank'):alertify("Success", response.data.message, "success");
        setIsSettlementDownloading(false);
    };

    const tableColumns = getDisbursementsTableColumns({ toggleDisbursementDetailsDrawer, downloadSettlementReport }, props?.current_user?.smart_collect_virtual_account_settings?.enable_settlement_mapping_report);


    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchDisbursements(_pagination, tableInfo.filters);
    };

    const tableFilters = disbursementFilterNodes(props.current_user);

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchDisbursements({ ..._pagination }, filters);
    };

    useEffect(() => {
        props.onTabRender('disbursements');
        let _filters = { ...filters };
        let defaultFilters = {};
        tableFilters.forEach(f => defaultFilters[f.field] = f.defaultValue);
        _filters = { ..._filters, ...defaultFilters };
        setFilters({ ..._filters });
        fetchDisbursements({ ...pagination }, { ..._filters });
    }, []);

    return (
        <div className="row">
            <div className="col-12">
                <EaseTable
                    rowKey="id"
                    loading={isTableLoading}
                    data={disbursements}
                    columns={tableColumns}
                    fixedSelectable={!isMobile}
                    handleTableChange={handleTableChange}
                    pagination={pagination}
                    totalRecords={pagination.total}
                    filterNodes={tableFilters}
                    downloadable={true}
                    onDownload={downloadReport}
                    isDownloading={isDownloading}
                    enableSettlementMappingReport={
                        props?.current_user?.smart_collect_virtual_account_settings?.enable_settlement_mapping_report
                    }
                    onSettlementMappingDownload={downloadSettlementMappingReport}
                    isSettlementMappingDownloading={isSettlementMappingDownloading}
                /><PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
            </div>
            <DisbursementDetailsDrawer
                visible={showDetailsDrawer}
                onClose={toggleDisbursementDetailsDrawer}
                disbursement={activeDisbursement}
            />
            <BulkUploadModal
                history={props.history}
                visible={props.showBulkRefundModal}
                toggleBulkUploadModal={props.toggleBulkRefundModal}
                onSuccess={() => fetchDisbursements(pagination, filters)}
                type="refund"
            />
        </div>
    )
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user,
    showBulkRefundModal: state.uiReducer.showBulkRefundModal
})

const mapDispatchToProps = (dispatch) => ({
    toggleBulkRefundModal: () => dispatch(toggleBulkRefundModalAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(Disbursements, 'IC_SETTLEMENT_REFUND_READ'));
